export const REQUEST_RETURNS = "REQUEST_RETURNS";
export const RECEIVE_RETURNS = "RECEIVE_RETURNS";

export const API_ERROR = "API_ERROR";

export const CLICK_DOWNLOAD_RETURN_ASSET = "CLICK_DOWNLOAD_RETURN_ASSET";
export const REQUEST_ASSET_ACCESS_TOKEN = "REQUEST_ASSET_ACCESS_TOKEN";
export const RECEIVE_ASSET_ACCESS_TOKEN = "RECEIVE_ASSET_ACCESS_TOKEN";
